"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var react_router_dom_1 = require("react-router-dom");
var lib_1 = require("@ribit/lib");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    style: "primary",
    type: "button",
    size: "regular",
    layout: "content",
    tabIndex: 0,
    disabled: false,
};
var isInternal = function (action) {
    return action.substr(0, 4) !== "http";
};
var Button = function (props) {
    var _a;
    var style = props.style, label = props.label, size = props.size, action = props.action, disabled = props.disabled, className = props.className, tabIndex = props.tabIndex, activeClassName = props.activeClassName, layout = props.layout;
    var tag = props.tag, type = props.type;
    var elementProps = {
        className: null,
        tabIndex: tabIndex,
    };
    var actionIsString = (0, lib_1.isString)(action);
    if (type === "button" || type === "submit") {
        elementProps.type = type;
        tag = type = "button";
        if (!disabled) {
            if (actionIsString) {
                if (!isInternal(action)) {
                    tag = "a";
                    elementProps = __assign(__assign({}, elementProps), { target: "_blank", href: action });
                }
                else {
                    var isActive = (0, react_router_dom_1.useMatch)(action);
                    elementProps = __assign(__assign({}, elementProps), { className: isActive ? activeClassName : undefined, to: action });
                    tag = react_router_dom_1.NavLink;
                }
            }
            else {
                elementProps.onClick = action;
            }
        }
    }
    else {
        if (actionIsString && isInternal(action)) {
            tag = react_router_dom_1.NavLink;
            var isActive = (0, react_router_dom_1.useMatch)(action);
            elementProps = __assign(__assign({}, elementProps), { className: isActive ? activeClassName : undefined, to: action });
        }
        else {
            tag = "a";
            if (actionIsString && !isInternal(action)) {
                elementProps = __assign(__assign({}, elementProps), { target: "_blank" });
            }
        }
        if (!disabled) {
            if (!actionIsString) {
                elementProps.onClick = action;
            }
            else {
                elementProps.href = action;
            }
        }
    }
    var layoutName = layout === "full-width" ? "fullWidth" : layout;
    var className_ = cx((_a = {},
        _a[type] = true,
        _a[style] = true,
        _a[size] = true,
        _a.disabled = disabled,
        _a[layoutName] = true,
        _a[className] = className,
        _a));
    elementProps.className = elementProps.className
        ? "".concat(elementProps.className, " ").concat(className_)
        : className_;
    var element = React.createElement(tag, elementProps, label);
    return element;
};
exports.Button = Button;
Button.defaultProps = defaultProps;
exports.default = Button;
//# sourceMappingURL=button.js.map